import { render, staticRenderFns } from "./ShortCodeComponent.vue?vue&type=template&id=93da15b8&"
import script from "./ShortCodeComponent.vue?vue&type=script&lang=js&"
export * from "./ShortCodeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports